// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.Table__wrapper .__pager {\n    position: relative;\n    top: -500px;\n\n    pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
